import { Button } from "@sellar-io/components";
import { OrderPaymentType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { Alert } from "../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useOrderCreateBuyerInvoice } from "../../../hooks/api/v2/order/useOrderCreateBuyerInvoice";
import { useOrderInvoiceReminder } from "../../../hooks/api/v2/order/useOrderInvoiceReminder";

export const OrderSendInvoiceReminderModal = ({
  active,
  onDismiss,
  buyerName,
  orderId,
  onSuccess,
  paymentType,
}: {
  active: boolean;
  onDismiss: () => void;
  orderId: number;
  buyerName: string;
  onSuccess: () => void;
  paymentType: OrderPaymentType | null;
}): ReactElement => {
  const orderInvoiceReminder = useOrderInvoiceReminder(orderId);
  const createBuyerInvoiceMutation = useOrderCreateBuyerInvoice(orderId);
  const sendReminder = () => {
    if (paymentType === "stripe") {
      return orderInvoiceReminder.mutate(undefined, {
        onSuccess: () => {
          onSuccess();
          onDismiss();
        },
      });
    }

    return createBuyerInvoiceMutation.mutate(
      {},
      {
        onSuccess: () => {
          onSuccess();
          onDismiss();
        },
      },
    );
  };
  const loading =
    orderInvoiceReminder.isPending || createBuyerInvoiceMutation.isPending;
  return (
    <Dialog onDismiss={onDismiss} active={active}>
      <DialogNavigation
        onClickLeftIcon={onDismiss}
        leftIcon={"CHEVRON_DOWN"}
        title="Send reminder to pay invoice"
        description={`We'll email ${buyerName} reminding them their payment is overdue.${
          paymentType === "stripe"
            ? " They'll receive a link to make a payment by credit or debit card."
            : ""
        }`}
      />
      {orderInvoiceReminder.isError && (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(orderInvoiceReminder.error)?.response?.data
              .message ?? "An unknown error occurred"
          }
        />
      )}
      {createBuyerInvoiceMutation.isError && (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(createBuyerInvoiceMutation.error)?.response?.data
              .message ?? "An unknown error occurred"
          }
        />
      )}
      <DialogCTA>
        <Button loading={loading} onClick={sendReminder}>
          Send
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
